/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  AuthContactMagicLinkLoginResponseData,
  AuthContactMagicLinkLoginResponseDataFromJSON,
  AuthContactMagicLinkLoginResponseDataFromJSONTyped,
  AuthContactMagicLinkLoginResponseDataToJSON
} from './AuthContactMagicLinkLoginResponseData'

/**
 *
 * @export
 * @interface AuthContactMagicLinkLoginResponse
 */
export interface AuthContactMagicLinkLoginResponse {
  /**
   *
   * @type {number}
   * @memberof AuthContactMagicLinkLoginResponse
   */
  status?: number
  /**
   *
   * @type {AuthContactMagicLinkLoginResponseData}
   * @memberof AuthContactMagicLinkLoginResponse
   */
  data?: AuthContactMagicLinkLoginResponseData
}

export function AuthContactMagicLinkLoginResponseFromJSON(json: any): AuthContactMagicLinkLoginResponse {
  return AuthContactMagicLinkLoginResponseFromJSONTyped(json, false)
}

export function AuthContactMagicLinkLoginResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthContactMagicLinkLoginResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : AuthContactMagicLinkLoginResponseDataFromJSON(json['data'])
  }
}

export function AuthContactMagicLinkLoginResponseToJSON(value?: AuthContactMagicLinkLoginResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: AuthContactMagicLinkLoginResponseDataToJSON(value.data)
  }
}
